"use strict";
// packages/types/src/processStep.ts
Object.defineProperty(exports, "__esModule", { value: true });
exports.ControlType = exports.StepType = void 0;
var StepType;
(function (StepType) {
    StepType["OPERATION"] = "operation";
    StepType["STORE"] = "store";
    StepType["INPUT"] = "input";
})(StepType || (exports.StepType = StepType = {}));
var ControlType;
(function (ControlType) {
    ControlType["QC"] = "QC";
    ControlType["CCP"] = "CCP";
    ControlType["PRP"] = "PRP";
    ControlType["CP"] = "CP";
    ControlType["NONE"] = "none";
})(ControlType || (exports.ControlType = ControlType = {}));
